import { api } from 'new/api/axios';
import getFetchHeaders, {
  createEndpoint,
  createFetchEndpoint,
} from 'new/api/utils';
import {
  AnalyticDashboardData,
  AnalyticDashboardDataRequest,
  GetDashboardColumnsRequest,
  ResponseColumns,
  SetDashboardColumnsRequest,
  ActivityFeedRequest,
  ActivityFeedResponse,
  ChangeTargetMemberRequest,
  UpcomingAppointmentsRequest,
  UpcomingAppointmentsResponse,
  ToggleCheckListItemRequest,
  LaunchRewardAcknowledgeRequest,
} from './types';
import { LogPageClickRequest } from '../Setup/types';
import Cookies from 'universal-cookie';
import { getEnvInfo } from 'new/utils/system';
const cookies = new Cookies();

export const getAnalyticDashboardData = createEndpoint<
  AnalyticDashboardData,
  AnalyticDashboardDataRequest
>({
  url: 'users/me/update-account/getDashboardData',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const getFeedData = createEndpoint<
  ActivityFeedResponse,
  ActivityFeedRequest
>({
  url: '/users/me/account/activityFeed',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const getAppointmentsData = createEndpoint<
  UpcomingAppointmentsResponse,
  UpcomingAppointmentsRequest
>({
  url: '/users/me/account/upcomingAppointments',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const getDashboardColumns = createEndpoint<
  ResponseColumns,
  GetDashboardColumnsRequest
>({
  url: 'users/me/update-account/getDashboardColumns',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const setDashboardColumns = createEndpoint<
  null,
  SetDashboardColumnsRequest
>({
  url: 'users/me/update-account/setDashboardColumns',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const changeTargetMemberCount = createEndpoint<
  unknown,
  ChangeTargetMemberRequest
>({
  url: '/dentists/targetMemberChange',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const toggleCheckListItemEndpoint = createEndpoint<
  unknown,
  ToggleCheckListItemRequest
>({
  url: '/dentists/check-launch-item',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const launchRewardAcknowledgeEndpoint = createEndpoint<
  unknown,
  LaunchRewardAcknowledgeRequest
>({
  url: '/users/me/update-account/launch-reward-acknowledge',
  endpoint: ({ url, params }) => api.post(url, params),
});

export const logPageClick = createFetchEndpoint<unknown, LogPageClickRequest>({
  url: '/dentist-info/logPageClick',
  endpoint: ({ url, params }) => {
    if (!cookies.get('beccascookie') || !getEnvInfo().isProd) {
      return fetch(url, {
        method: 'POST',
        body: JSON.stringify(params),
        headers: getFetchHeaders(),
        keepalive: true,
      });
    } else return Promise.resolve();
  },
});
